/**
 * DNSSEC and DANE test type
 */
export const DNSSEC_AND_DANE_TEST = "DnssecAndDaneTest";

/**
 * DNSSEC only test type
 */
export const DNSSEC_ONLY_TEST = "DnssecOnlyTest";

/**
 * Baseline test
 */
export const DNS_BASELINE_TEST = "BaselineTest";

/**
 * Test type for the Dane Validation test
 */
export type IDaneValidationTestType = typeof DNSSEC_AND_DANE_TEST | typeof DNSSEC_ONLY_TEST | typeof DNS_BASELINE_TEST;
